import { BINANCE_WS_BASE_URL } from 'config'
import {
  BINANCE_RESOLUTION_OPTIONS,
  ZKEX_SYMBOL_TO_BINANCE_API,
} from 'constants/chart'
import { store } from 'store'
import { TradeType } from 'store/market/types'
import {
  updateBinanceLastBar,
  updateBinanceTimeConnect,
} from 'store/orderbook/actions'
import { connectionUniqueId } from 'utils/datafeed/binance'
import { sleep } from 'utils/sleep'

const url = BINANCE_WS_BASE_URL + '/v1/kline?unique_id=' + connectionUniqueId()

let binanceWs: WebSocket = new WebSocket(url)
window.binanceWs = binanceWs

export function initBinanceWebSocket() {
  binanceWs.onmessage = function (event) {
    const data = JSON.parse(event.data || '')
    if (data?.ty === 'kline') {
      store.dispatch(updateBinanceLastBar(data?.da))
    }
  }
  binanceWs.onopen = function (event) {
    console.warn('BinanceWebSocket is open now.')
    // store.dispatch(updateWsAvailable({ binance: 1 }))
  }
  binanceWs.onclose = function (event) {
    console.warn('BinanceWebSocket is closed now.')
    // store.dispatch(updateWsAvailable({ binance: 0 }))
    reconnectBinance()
  }
  binanceWs.onerror = function (event) {
    console.error('Binance ws connection error: ', event)
  }
}
let timeConnect = 0
let lockReconnect = false
export function reconnectBinance() {
  if (lockReconnect) {
    return
  }
  console.log('binance websocket reconnect.')
  lockReconnect = true
  timeConnect++
  setTimeout(function () {
    binanceWs = new WebSocket(url)
    window.binanceWs = binanceWs
    store.dispatch(updateBinanceTimeConnect(timeConnect))
    initBinanceWebSocket()
    lockReconnect = false
  }, 20000)
}
interface BinanceSendData {
  action: 'subscribe' | 'unsubscribe' | 'ping'
  symbol?: string
  interval?: string
  exchange?: string
}
export async function send(data: BinanceSendData, op?: any, cb?: any) {
  let sendData: string = ''
  if (binanceWs.readyState === binanceWs.OPEN) {
    if (typeof data !== 'string') {
      sendData = JSON.stringify(data)
    }
    binanceWs.send(sendData)
  } else {
    await sleep(200)
    send(data, op, cb)
  }
}
export const subscribeBinanceKLines = (
  symbol: string,
  localInterval: string,
) => {
  const interval = BINANCE_RESOLUTION_OPTIONS[localInterval]

  const _store = store.getState()
  const _type = _store.market.trade

  const exchange =
    _type === TradeType.Perp ? 'binance:contract' : 'binance:spot'
  const data: BinanceSendData = {
    action: 'subscribe',
    symbol: ZKEX_SYMBOL_TO_BINANCE_API[symbol],
    interval,
    exchange,
  }
  send(data)
  return () => {
    send({ ...data, action: 'unsubscribe' })
  }
}
export const subscribeBinancePing = () => {
  const data: BinanceSendData = {
    action: 'ping',
  }
  const timer = setInterval(() => {
    send(data)
  }, 10000)
  return () => {
    clearInterval(timer)
  }
}
